export default __webpack_public_path__ + "static/media/ic-edit.1de8068b.svg";